import { render, staticRenderFns } from "./MWaterAnalysis.vue?vue&type=template&id=079269a8&scoped=true"
import script from "./MWaterAnalysis.vue?vue&type=script&lang=js"
export * from "./MWaterAnalysis.vue?vue&type=script&lang=js"
import style0 from "./MWaterAnalysis.vue?vue&type=style&index=0&id=079269a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079269a8",
  null
  
)

export default component.exports